
riot.tag2('img_loader', '<yield></yield>', '', '', function(opts) {
this.on('mount', function() {
  return this.root.onerror = (function(_this) {
    return function(err) {
      return setTimeout(function() {
        if ((opts["default"] != null) && _this.root.src !== opts["default"]) {
          _this.root.src = opts["default"];
          return _this.update();
        }
      });
    };
  })(this);
});
});